<template>
  <div class="row page-header">
    <div v-if="backUrl" class="col">
      <router-link class="nav-link" :to="{name:backUrl, params: urlParameters}">
        <font-awesome-icon icon="chevron-left" class="mr-2" />{{ $t('Back') }}
      </router-link>
    </div>
    <div :class="[{'col': backUrl === undefined, 'page-header__title--left': backUrl === undefined}, 'page-header__title', 'font-weight-bold']">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHeading",
  props: ['backUrl', 'title', 'urlParams'],
  computed: {
    urlParameters: function() {
      return (this.urlParams) ? this.urlParams : {};
    }
  }
}
</script>

<style scoped lang="scss">
  .nav-link {
    position: relative;

    &:after {
      position: absolute;
      content: '\200C';
      width: 2px;
      background: $border-color;
      height: 75%;
      top: 13%;
      right: 0;
    }
  }
</style>
